/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
export enum FacetMode {
    // every subprovider separate as a subtree, with a root with subprovider_all
    "tree" = "tree",
    // all subprovider facets will be merged and sorted
    "flat" = "flat",
}
